import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-6277">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-6278">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-6279">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-6280">
            <ArrowLeft className="w-4 h-4" data-id="element-6281" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-6282">NOIZA</div>
          <div className="w-20" data-id="element-6283" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-6284">
        <div className="mb-12" data-id="element-6285">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-6286">
            <FileText className="w-6 h-6 text-white/80" data-id="element-6287" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-6288">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-6289">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-6290">
          <section data-id="element-6291">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6292">
              <span className="text-[#006847]" data-id="element-6293">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6294">
              <p data-id="element-6295">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-6296">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6297">
                <li data-id="element-6298">Haber leído íntegramente este documento</li>
                <li data-id="element-6299">Comprender su contenido en su totalidad</li>
                <li data-id="element-6300">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-6301">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-6302">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6303">
              <span className="text-[#006847]" data-id="element-6304">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6305">
              <p data-id="element-6306">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6307">
                <li data-id="element-6308">Software como servicio (SaaS)</li>
                <li data-id="element-6309">Marketplace digital gastronómico</li>
                <li data-id="element-6310">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-6311">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6312">
                <li data-id="element-6313">Mostrar su menú digital</li>
                <li data-id="element-6314">Recibir pedidos de clientes</li>
                <li data-id="element-6315">Gestionar su operación interna</li>
                <li data-id="element-6316">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-6317">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-6318">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6319">
              <span className="text-[#006847]" data-id="element-6320">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6321">
              <p data-id="element-6322">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6323">
                <li data-id="element-6324">No es proveedor de alimentos</li>
                <li data-id="element-6325">No participa en la preparación de productos</li>
                <li data-id="element-6326">No manipula alimentos en ningún momento</li>
                <li data-id="element-6327">No realiza entregas ni logística</li>
                <li data-id="element-6328">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-6329">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-6330">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-6331">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6332">
              <span className="text-[#006847]" data-id="element-6333">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-6334">
              <p data-id="element-6335">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-6336">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6337">
                <li data-id="element-6338">El restaurante es el único responsable de su operación</li>
                <li data-id="element-6339">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-6340">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-6341">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6342">
                <li data-id="element-6343">Precios</li>
                <li data-id="element-6344">Menú</li>
                <li data-id="element-6345">Horarios</li>
                <li data-id="element-6346">Métodos de pago</li>
                <li data-id="element-6347">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6348">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6349">
              <span className="text-[#006847]" data-id="element-6350">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-6351">
              <div data-id="element-6352">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6353">
                  5.1. Alcance general
                </h3>
                <p data-id="element-6354">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-6355">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6356">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-6357">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6358">
                  <li data-id="element-6359">Calidad de los alimentos</li>
                  <li data-id="element-6360">Estado, frescura o preparación</li>
                  <li data-id="element-6361">Ingredientes utilizados</li>
                  <li data-id="element-6362">Contaminación cruzada</li>
                  <li data-id="element-6363">Problemas de higiene o salubridad</li>
                  <li data-id="element-6364">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6365">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-6366">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6367">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-6368">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6369">
                  <li data-id="element-6370">Retrasos en la entrega</li>
                  <li data-id="element-6371">Pérdida de pedidos</li>
                  <li data-id="element-6372">Entregas incompletas</li>
                  <li data-id="element-6373">Errores en dirección</li>
                  <li data-id="element-6374">Conducta de repartidores</li>
                  <li data-id="element-6375">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-6376">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6377">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-6378">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-6379">
                  <li data-id="element-6380">Recepción de pagos</li>
                  <li data-id="element-6381">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-6382">Manejo de efectivo</li>
                  <li data-id="element-6383">Confirmación de pagos</li>
                  <li data-id="element-6384">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-6385">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6386">
                  <li data-id="element-6387">Pagos no recibidos</li>
                  <li data-id="element-6388">Comprobantes falsos</li>
                  <li data-id="element-6389">Errores en montos</li>
                  <li data-id="element-6390">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-6391">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6392">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-6393">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6394">
                  <li data-id="element-6395">Reclamos de clientes</li>
                  <li data-id="element-6396">Reembolsos</li>
                  <li data-id="element-6397">Cancelaciones</li>
                  <li data-id="element-6398">Disputas</li>
                  <li data-id="element-6399">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6400">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-6401">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6402">
              <span className="text-[#006847]" data-id="element-6403">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-6404">
              <p data-id="element-6405">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6406">
                <li data-id="element-6407">Responsable</li>
                <li data-id="element-6408">Legal</li>
                <li data-id="element-6409">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-6410">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6411">
                <li data-id="element-6412">Publicar información falsa</li>
                <li data-id="element-6413">Manipular precios de forma engañosa</li>
                <li data-id="element-6414">Simular disponibilidad inexistente</li>
                <li data-id="element-6415">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6416">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6417">
              <span className="text-[#006847]" data-id="element-6418">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-6419">
              <p data-id="element-6420">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6421">
                <li data-id="element-6422">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-6423">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-6424">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6425">
                <li data-id="element-6426">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-6427">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-6428">
                    <li data-id="element-6429">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-6430">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-6431">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6432">
              <span className="text-[#006847]" data-id="element-6433">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-6434">
              <p data-id="element-6435">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6436">
                <li data-id="element-6437">Menú digital</li>
                <li data-id="element-6438">Gestión de pedidos</li>
                <li data-id="element-6439">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-6440">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6441">
                  <p className="font-medium text-white mb-2" data-id="element-6442">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6443">
                    <li data-id="element-6444">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6445">
                  <p className="font-medium text-white mb-2" data-id="element-6446">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6447">
                    <li data-id="element-6448">Propiedad del software</li>
                    <li data-id="element-6449">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-6450">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-6451">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6452">
              <span className="text-[#006847]" data-id="element-6453">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6454">
              <p data-id="element-6455">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6456">
                <li data-id="element-6457">Disponibilidad continua</li>
                <li data-id="element-6458">Funcionamiento sin interrupciones</li>
                <li data-id="element-6459">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-6460">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6461">
                <li data-id="element-6462">Fallas técnicas</li>
                <li data-id="element-6463">Actualizaciones</li>
                <li data-id="element-6464">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-6465">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-6466">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6467">
              <span className="text-[#006847]" data-id="element-6468">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-6469">
              <p data-id="element-6470">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6471">
                <li data-id="element-6472">No está garantizada permanentemente</li>
                <li data-id="element-6473">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-6474">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6475">
                <li data-id="element-6476">Destacar o no restaurantes</li>
                <li data-id="element-6477">Modificar posiciones</li>
                <li data-id="element-6478">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6479">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6480">
              <span className="text-[#006847]" data-id="element-6481">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-6482">
              <p data-id="element-6483">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6484">
                <li data-id="element-6485">Cumplir con los pagos acordados</li>
                <li data-id="element-6486">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-6487">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6488">
                <li data-id="element-6489">Suspender el servicio</li>
                <li data-id="element-6490">Limitar funcionalidades</li>
                <li data-id="element-6491">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6492">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6493">
              <span className="text-[#006847]" data-id="element-6494">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6495">
              <p data-id="element-6496">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6497">
                <li data-id="element-6498">Incumplimiento de términos</li>
                <li data-id="element-6499">Uso indebido</li>
                <li data-id="element-6500">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-6501">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-6502">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6503">
              <span className="text-[#006847]" data-id="element-6504">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-6505">
              <p data-id="element-6506">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-6507">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-6508">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6509">
              <span className="text-[#006847]" data-id="element-6510">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-6511">
              <p data-id="element-6512">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6513">
                <li data-id="element-6514">Pérdidas económicas</li>
                <li data-id="element-6515">Daños indirectos</li>
                <li data-id="element-6516">Lucro cesante</li>
                <li data-id="element-6517">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6518">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6519">
              <span className="text-[#006847]" data-id="element-6520">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-6521">
              <p data-id="element-6522">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-6523">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6524">
              <span className="text-[#006847]" data-id="element-6525">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-6526">
              <p className="font-medium" data-id="element-6527">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-6528">
                <li data-id="element-6529">Ha leído este documento completo</li>
                <li data-id="element-6530">Comprende su alcance</li>
                <li data-id="element-6531">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}